import { Node } from 'slate';
import {
  DEFINITIONS as PLUGIN_DEFINITIONS,
  CAPTION_DEFINITIONS,
} from '@xingternal/content-editor-plugin-image';

import {
  DESERIALIZATION,
  SERIALIZATION,
  IMAGE_FIELDNAME,
  IMAGE_TYPENAME,
  BODY_IMAGE_PARAM_TYPE_UUID,
  BODY_IMAGE_PARAM_TYPE_UPLOAD_ID,
} from '../constants';

const OUTPUT_DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: IMAGE_TYPENAME,
};

const imageSerializer = ({ createBlock, matchBlock, node, direction }) => {
  if (matchBlock({ node, match: OUTPUT_DEFINITIONS })) {
    if (direction === SERIALIZATION) {
      const { uploadId, uuid, id } = node.data;
      const caption = Node.child(node, 0);

      return uuid
        ? {
            [IMAGE_FIELDNAME]: {
              id,
              inputType: BODY_IMAGE_PARAM_TYPE_UUID,
              inputValue: uuid,
              caption: { text: Node.string(caption) || '' },
            },
          }
        : {
            [IMAGE_FIELDNAME]: {
              id,
              inputType: BODY_IMAGE_PARAM_TYPE_UPLOAD_ID,
              inputValue: uploadId,
              caption: { text: Node.string(caption) || '' },
            },
          };
    }
    if (direction === DESERIALIZATION) {
      return createBlock({
        node,
        definitions: OUTPUT_DEFINITIONS,
        data: {
          id: node.id,
          url: node.image[0].url,
          uuid: node.uuid,
          images: node.image,
        },
        children: [
          {
            type: CAPTION_DEFINITIONS.type,
            children: [{ text: node.caption.text || '' }],
          },
        ],
      });
    }
  }
};

export { imageSerializer };
